moment.updateLocale(trans('common.language_encode_short'), { week: {
  dow: 1, // First day of week is Monday
  doy: 4  // First week of year must contain 4 January (7 + 1 - 4)
}});

function generateEventFeeds(step) {

    // Populate the time picker
    var fromDate = null;
    var toDate = null;

    var today = moment();

    var page = parseInt($('[data-page]').attr('data-page')) + step;
    $('[data-page]').attr('data-page', page);

    var pickerText = trans("common.this_week");

    if (window.showO) { // If there are not down events in log, we can display announcements only - for longer time period

        if (page === 0) {
            toDate = moment();
            fromDate = moment().startOf('isoweek');
        } else {
            fromDate = moment().subtract(Math.abs(page) * 7, 'days').startOf('isoweek');
            toDate = moment().subtract(Math.abs(page) * 7, 'days').endOf('isoweek');
        }

        if (page !== 0) {
            pickerText = fromDate.format('MMM Do \'YY') + ' ' + trans('common.to') + ' ' + toDate.format('MMM Do \'YY');
        }

        if (Math.abs(page) == 104) { // 24 months - two years before
            $('.calendar-prev').prop('disabled', true);
        } else {
            $('.calendar-prev').prop('disabled', false);
        }

    } else {

        if (page === 0) {
            toDate = moment();
            fromDate = moment().startOf('month');
        } else {
            fromDate = moment().subtract(Math.abs(page), 'months').startOf('month');
            toDate = moment().subtract(Math.abs(page), 'months').endOf('month');
        }

        pickerText = fromDate.format('MMM YYYY');

        if (Math.abs(page) == 24) { // 104weeks - two years before
            $('.calendar-prev').prop('disabled', true);
        } else {
            $('.calendar-prev').prop('disabled', false);
        }

    }

    $('.calendar-timepicker').text(pickerText);


    if (page == 0) {
        $('.calendar-next').prop('disabled', true);
    } else {
        $('.calendar-next').prop('disabled', false);
    }

    callEventFeed(false, toDate.unix() * 1000, fromDate.unix() * 1000, $('#weekly-feed')); // fromNow? ; fromDate, toDate; outputContainer

}

$('.calendar-prev').on('click', function () {
    generateEventFeeds(-1);
});

$('.calendar-next').on('click', function () {
    generateEventFeeds(1);
});

$(document).ready(function () {
    generateEventFeeds(0, 0);
});
